import jquery from 'jquery';
import moment from 'moment';
import c from '@/components/Core/constants.js'

import { View, createPlugin, DateProfile } from '@fullcalendar/core';

import WeekDayRender from './Monthly/WeekDayRender/WeekDayRender.js';
import MonthsRender from './Monthly/MonthsRender/MonthsRender.js';

import Loading from 'Vue/VueStyleGuide/Components/Spinner/service.js';
import store from '../../../../../store/store.js';

class CustomViewMonthly extends View {
	// htmlContainer = `
	//   <div class="fc-ob-custom-view fc-ob-custom-view-monthly">
	//     <div class="fc-ob-custom-view-header"></div>
	//     <div class="fc-ob-custom-view-body"></div>
	//     <div class="fc-ob-custom-view-footer"></div>
	//   </div>
	// `;

	// CalendarList = [];
	// searchText = "";
	// pageNo = 0;
	// pageSize = 12;
	// orgId = "";
	// month = "";
	// year = "";

	setDefault() {
		this.htmlContainer = `
		<div class="fc-ob-custom-view fc-ob-custom-view-monthly">
			<div id="calenderDiv" style="overflow :hidden ;margin-bottom:5px" class="fc-ob-custom-view-header"></div>
			<div id="CalenderInnerDiv" style="overflow-x: auto;overflow-y: auto;margin-right: -15px;">
			<div  class="fc-ob-custom-view-body"> </div>
			<div style="position:sticky;left:0"  class="fc-ob-custom-view-footer"></div>
			</div>

			<div  class="fc-ob-custom-view-pagination"></div>
		</div>
  `;

		this.CalendarList = [];
		this.searchText = '';
		this.pageNo = 1;
		this.pageSize = 12;
		this.orgId = '';
		this.month = '';
		this.year = '';

		this.TotalCount = 0;

		this.TotalEmployeeList = [];
		this.SelectedTimesheets = [];
		this.UnSelectedTimesheets = [];
	}

	getHeaderDOM() {
		return jquery(this.el).find('.fc-ob-custom-view .fc-ob-custom-view-header');
	}

	getBodyDOM() {
		return jquery(this.el).find('.fc-ob-custom-view .fc-ob-custom-view-body');
	}

	getFooterDOM() {
		return jquery(this.el).find('.fc-ob-custom-view .fc-ob-custom-view-pagination');
	}

	clearDOM() {
		jquery(this.el).html(this.htmlContainer);
	}
	createPageNumber(startIndex, lastIndex) {
		let paginationHtml = '';
		for (var i = startIndex; i <= lastIndex; i++) {
			if (this.pageNo == i) {
				paginationHtml += `<li class="timesheet-pageNumber" index="${i}"><a class="active">${i}</a></li>`;
			} else {
				paginationHtml += `<li  class="timesheet-pageNumber" index="${i}"><a >${i}</a></li>`;
			}
		}
		return paginationHtml;
	}
	PaginationBind() {
		let total = parseInt(Math.ceil(this.TotalCount / this.pageSize));
		if(total > 1)
		{

			var paginationHtml = `<ul class="timesheet-pagination">
					<li><a class="timesheet-pagination-first"> <i  class="fa fa-angle-double-left " aria-hidden="true"></i> </a> </li>
					<li><a class="timesheet-pagination-prev"> <i  class="fa fa-angle-left " aria-hidden="true"></i> </a></li>
			`;

			if (total <= 10) {
				paginationHtml += this.createPageNumber(1, total);

				// for (var i = total + 1; i <= 13; i++) {
				// 	paginationHtml += `<li><a disabled>-</a></li>`;
				// }
			} else if (total > 10) {
				if (this.pageNo <= 3) {
					paginationHtml += this.createPageNumber(1, 3);

					paginationHtml += `<li><a >...</a></li>`;

					let middleCount = parseInt(Math.floor(total / 2));
					paginationHtml += this.createPageNumber(middleCount - 1, middleCount + 1);

					paginationHtml += `<li><a >...</a></li>`;

					var lastForCount = parseInt(total - 2);
					paginationHtml += this.createPageNumber(lastForCount, total);
				} else if (this.pageNo >= 4 && this.pageNo <= 5) {
					paginationHtml += this.createPageNumber(1, 5);

					paginationHtml += `<li><a >...</a></li>`;

					let middleCount = parseInt(Math.floor(total / 2));
					paginationHtml += this.createPageNumber(middleCount, middleCount);

					paginationHtml += `<li><a >...</a></li>`;

					var lastForCount = parseInt(total - 2);
					paginationHtml += this.createPageNumber(lastForCount, total);
				} else if (this.pageNo >= total - 4) {
					paginationHtml += this.createPageNumber(1, 3);

					paginationHtml += `<li><a >...</a></li>`;

					let middleCount = parseInt(Math.floor(total / 2));
					paginationHtml += this.createPageNumber(middleCount, middleCount);

					paginationHtml += `<li><a >...</a></li>`;

					paginationHtml += this.createPageNumber(total - 4, total);
				} else if (this.pageNo >= 6 && this.pageNo <= total - 5) {
					paginationHtml += this.createPageNumber(1, 3);

					paginationHtml += `<li><a >...</a></li>`;
					var lastForCount = parseInt(total - 3);

					let middleCount = parseInt(this.pageNo);

					if (this.pageNo > total - 3) {
						middleCount = parseInt(Math.floor(total / 2));
					}

					paginationHtml += this.createPageNumber(middleCount - 1, middleCount + 1);

					paginationHtml += `<li><a >...</a></li>`;

					var lastForCount = parseInt(total - 2);
					paginationHtml += this.createPageNumber(lastForCount, total);
				}
			}
			if(total > 10)
			{
				paginationHtml += `
				<li><a class="timesheet-pagination-next"> <i class="fa fa-angle-right" aria-hidden="true"></i> </a></li>
				<li><a class="timesheet-pagination-last" > <i class="fa fa-angle-double-right" aria-hidden="true"></i> </a></li>
				<li><span style="width: 38px;display: inline-block;" >Go to</span><span style="width: 80px;" >Page</span></li>
				<li><span> <input id="page-number-txt" min="1" max="${total}" style="height: 15px !important;	border-radius: 5px;	border: 1px solid #00000078;margin:5px"  type="number" onkeyup="trim()" class="fc-cv-go-to-txt"> </span></li>
				<li> <span> <button disabled id="page-number-btn" style="color: #fff; background-color: #143361;  height: 28px;  width: 30px; border-radius: 5px;border: none;"  class="fc-cv-go-to-btn">Go</button> </span></li>
				</ul>`;
			}
			else
			{
				paginationHtml += `
				<li><a class="timesheet-pagination-next"> <i class="fa fa-angle-right" aria-hidden="true"></i> </a></li>
				<li><a class="timesheet-pagination-last" > <i class="fa fa-angle-double-right" aria-hidden="true"></i> </a></li>
				</ul>`;
			}
			return paginationHtml;
	    }
	}
	handleManulRemaindersOnPageLoad()
	{
		var IsSelectAll = store.getters.getIsSelectAllForManualRemainders;
		let _this = this;
		if(IsSelectAll){
			jquery('.employer_background_image_calender').each(function() {

				let empId = jquery(this).attr('emp_id');

			   var remainderObjIndex = _this.UnSelectedTimesheets.findIndex((x) => x.id == empId);
               if (remainderObjIndex == -1) {
					jquery(this).addClass('active');
					jquery(this).css('background-size', '31px 32px !important');
					jquery(this).css('background-image', `url('${c.CDNIMAGESBASEURL}/ess/ESSApp/static/Images/timasheet_emp_ic_selected_can.svg')`);
					jquery(this).parent().parent().parent().parent().css({
						border: '2px solid #4a90e2'
					});
			   }
			});
		}
		else{
			jquery('.employer_background_image_calender').each(function() {

				let empId = jquery(this).attr('emp_id');
			   var remainderObjIndex = _this.SelectedTimesheets.findIndex((x) => x.id == empId);
               if (remainderObjIndex != -1) {
					jquery(this).addClass('active');
					jquery(this).css('background-size', '31px 32px !important');
					jquery(this).css('background-image', `url('${c.CDNIMAGESBASEURL}/ess/ESSApp/static/Images/timasheet_emp_ic_selected_can.svg')`);
					jquery(this).parent().parent().parent().parent().css({
						border: '2px solid #4a90e2'
					});
			   }
			});
		}
	}
	pageNumberUrlHandling()
	{
		if (history.pushState) {

			var calenderDate = decodeURIComponent(this.getUrlVars()['calenderDate']);
			var searchText = decodeURIComponent(this.getUrlVars()['searchText']);
			
			if(searchText == "undefined")
			{
				searchText = ''
			}
			if(this.searchText != '' && this.searchText != undefined && this.searchText != null){
				searchText = this.searchText
			}

			var baseUEL = window.location.protocol + '//' + window.location.host + window.location.pathname;
			var newurl = '';
			if (calenderDate != undefined && calenderDate != null && searchText != undefined && searchText != null) {
				newurl = baseUEL + '?searchText=' + searchText + '&calenderDate=' + calenderDate + '&pageNo='+ this.pageNo+'';
			}else if(calenderDate != undefined && calenderDate != null ) {
				newurl = baseUEL  + '?calenderDate=' + calenderDate + '&pageNo='+this.pageNo+'';
			}else if(searchText != undefined && searchText != null)
			{
				newurl = baseUEL + '?searchText=' + searchText +  '&pageNo='+this.pageNo+'';
			}
			else{
				newurl = baseUEL + '?pageNo='+this.pageNo+'';
			}
			window.history.pushState({ path: newurl }, '', newurl);
		}
	}
	bindEvents() {
		let _this = this;
		let totalCount = Math.ceil(_this.TotalCount / _this.pageSize);

		jquery(function() {
			if (_this.pageNo == 1) {
				$('.timesheet-pagination-first').attr('style', 'cursor: not-allowed !important');
				$('.timesheet-pagination-prev').attr('style', 'cursor: not-allowed !important');
			}
			if (_this.pageNo == totalCount) {
				$('.timesheet-pagination-next').attr('style', 'cursor: not-allowed !important');
				$('.timesheet-pagination-last').attr('style', 'cursor: not-allowed !important');
			}
		});

		jquery('.Expense-re').unbind('click').click(function() {
			var ExemployeeId = jquery(this).attr('emp_id');
			console.log('selected Empid', ExemployeeId);
			window.bus.fire('OnArrowClick', this, ExemployeeId);
		});

		jquery('.fc-ce-bg').unbind('click').click(function() {
			var eventObj = [];
			var employeeId = jquery(this).attr('data-employee-id');
			var eIds = jquery(this).attr('data-event-id');
			var eventId = eIds.split(',');
			var employeeIndex = _this.CalendarList.findIndex((c) => c.EmployeeId == employeeId);
			if (employeeIndex != -1) {
				let employee = _this.CalendarList[employeeIndex];
				for (var k = 0; k < eventId.length; k++) {
					let eventIndex = employee.CalendarList.findIndex((e) => e.Id == eventId[k]);
					if (eventIndex != -1) {
						let event = employee.CalendarList[eventIndex];

						var obj = {
							defs: JSON.stringify(event),
							el: jquery(this)[0]
						};
						eventObj.push(obj);
					}
				}
				window.bus.fire('OnTimesheetLengendClick', eventObj);
				//_this.publiclyTrigger('eventClick', [ eventObj ]);
			}
		});

		jquery('.fc-cv-search-btn').unbind('click').click(function() {
			_this.getBodyDOM().html(''); // Clear existing data
			_this.getFooterDOM().html(''); // Clear existing data
			_this.pageNo = 1;
			_this.searchText = jquery('.fc-cv-search-input').val();
			_this.CalendarList = [];

			jquery('#no_of_emp_remainder').css('display', 'None');
			jquery('#no_of_emp_remainder_num').html(``);

			store.commit('UpdateIsSelectAllForManualRemainders', false);
			_this.SelectedTimesheets = [];
			_this.UnSelectedTimesheets = [];

			if (history.pushState) {
				var calenderDate = _this.getUrlVars()['calenderDate'];
				var baseUEL = window.location.protocol + '//' + window.location.host + window.location.pathname;
				var newurl = '';
				if (calenderDate) {
					newurl = baseUEL + '?searchText=' + _this.searchText + '&calenderDate=' + calenderDate + '';
				} else {
					newurl = baseUEL + '?searchText=' + _this.searchText + '';
				}
				window.history.pushState({ path: newurl }, '', newurl);
			}
			store.commit('updateTimesheetPageNo', 1);
			_this.makeAjaxCall();
		});

		jquery('.fc-ob-load-more-link').unbind('click').click(function() {
			_this.pageNo++;
			var position = document.getElementById('CalenderInnerDiv').scrollTop;
			store.commit('updateTimesheetPageNo', _this.pageNo);
			store.commit('updateTimesheetScrollPosition', position);
			_this.IsPagefullLoad = false;
			_this.makeAjaxCall();
		});

		jquery('.timesheet-pagination-next').unbind('click').click(function() {
			if (_this.pageNo < totalCount) {
				_this.pageNo++;
				var position = document.getElementById('calenderDiv').scrollTop;
				store.commit('updateTimesheetPageNo', _this.pageNo);
				store.commit('updateTimesheetScrollPosition', position);
				_this.IsPagefullLoad = false;
				_this.pageNumberUrlHandling();
				_this.makeAjaxCall();
			}
		});
		jquery('.timesheet-pagination-prev').unbind('click').click(function() {
			if (_this.pageNo > 1) {
				_this.pageNo--;
				var position = document.getElementById('calenderDiv').scrollTop;
				store.commit('updateTimesheetPageNo', _this.pageNo);
				store.commit('updateTimesheetScrollPosition', position);
				_this.IsPagefullLoad = false;
				_this.pageNumberUrlHandling();
				_this.makeAjaxCall();
			}
		});
		jquery('.timesheet-pagination-first').unbind('click').click(function() {
			if (_this.pageNo > 1) {
				_this.pageNo = 1;
				var position = document.getElementById('calenderDiv').scrollTop;
				store.commit('updateTimesheetPageNo', _this.pageNo);
				store.commit('updateTimesheetScrollPosition', position);
				_this.IsPagefullLoad = false;
				_this.pageNumberUrlHandling();
				_this.makeAjaxCall();
			}
		});
		jquery('.timesheet-pagination-last').unbind('click').click(function() {
			if (_this.pageNo < totalCount) {
				let total = _this.TotalCount / _this.pageSize;
				_this.pageNo = Math.ceil(total);
				var position = document.getElementById('calenderDiv').scrollTop;
				store.commit('updateTimesheetPageNo', _this.pageNo);
				store.commit('updateTimesheetScrollPosition', position);
				_this.IsPagefullLoad = false;
				_this.pageNumberUrlHandling();
				_this.makeAjaxCall();
			}
		});

		jquery('.timesheet-pageNumber').unbind('click').click(function() {
			let index = parseInt(jquery(this).attr('index'));
			if(!this.firstChild.classList.contains('active'))
			{
				_this.pageNo = index;
				var position = document.getElementById('calenderDiv').scrollTop;
				store.commit('updateTimesheetPageNo', _this.pageNo);
				store.commit('updateTimesheetScrollPosition', position);
				_this.IsPagefullLoad = false;
				_this.pageNumberUrlHandling();
				_this.makeAjaxCall();
			}
		});

		jquery('#page-number-btn').unbind('click').click(function() {
			let num = jquery('#page-number-txt').val();
			_this.pageNo = num;
			var position = document.getElementById('calenderDiv').scrollTop;
			store.commit('updateTimesheetPageNo', _this.pageNo);
			store.commit('updateTimesheetScrollPosition', position);
			_this.IsPagefullLoad = false;
			_this.pageNumberUrlHandling();
			_this.makeAjaxCall();
		});

		jquery('#page-number-txt').keyup(function() {
			var max = parseInt(jquery(this).attr('max'));
			var min = parseInt(jquery(this).attr('min'));
			let num = jquery(this).val();
			if (num != null && num != '') {
				if (num > max) {
					jquery(this).val(max);
				} else if (num < min) {
					jquery(this).val(min);
				}
				document.getElementById('page-number-btn').disabled = false;
			} else {
				document.getElementById('page-number-btn').disabled = true;
			}
		});

		jquery('.fc-cv-search-input').unbind('keyup').keyup(function(e) {
			if (e.keyCode == 13) {
				_this.getBodyDOM().html(''); // Clear existing data
				_this.getFooterDOM().html(''); // Clear existing data
				_this.pageNo = 1;
				_this.searchText = jquery(this).val();
				_this.CalendarList = [];
				jquery('#no_of_emp_remainder').css('display', 'None');
				jquery('#no_of_emp_remainder_num').html(``);
				store.commit('UpdateIsSelectAllForManualRemainders', false);
				_this.SelectedTimesheets = [];
				_this.UnSelectedTimesheets = [];
				if (history.pushState) {
					var calenderDate = _this.getUrlVars()['calenderDate'];
					var baseUEL = window.location.protocol + '//' + window.location.host + window.location.pathname;
					var newurl = '';
					if (calenderDate) {
						newurl = baseUEL + '?searchText=' + _this.searchText + '&calenderDate=' + calenderDate + '';
					} else {
						newurl = baseUEL + '?searchText=' + _this.searchText + '';
					}
					window.history.pushState({ path: newurl }, '', newurl);
				}
				store.commit('updateTimesheetPageNo', 1);
				_this.makeAjaxCall();
			}
		});

		jquery('.fc-cv-remove-btn').unbind('click').click(function() {
			_this.getBodyDOM().html(''); // Clear existing data
			_this.getFooterDOM().html(''); // Clear existing data
			_this.pageNo = 1;
			_this.searchText = '';
			_this.CalendarList = [];
			jquery('.fc-cv-search-input').val('');
			_this.updateURL();
			store.commit('updateTimesheetPageNo', 1);

			jquery('#no_of_emp_remainder').css('display', 'None');
			jquery('#no_of_emp_remainder_num').html(``);
			store.commit('UpdateManualRemainderEmpIds', []);

			_this.makeAjaxCall();
		});

		var leftDiv = document.getElementById('CalenderInnerDiv');
		var rightDiv = document.getElementById('calenderDiv');
		if (leftDiv != null && leftDiv != undefined && rightDiv != null && rightDiv != undefined) {
			leftDiv.onscroll = function() {
				{
					rightDiv.scrollLeft = this.scrollLeft;
				}
			};
			leftDiv.style.minHeight = window.innerHeight - 230 + 'px';
			leftDiv.style.maxHeight = window.innerHeight - 230 + 'px';
			//for Manual reminders
			jquery('.emp_rem_selectAll').on('click', function() {
				var manualRemainderEmpIds = [];
				var empNum = _this.TotalEmployeeList.length;

				for(var i = 0 ; i < _this.TotalEmployeeList.length ; i++)
				{
					var remainderEmpObj = {
						id: _this.TotalEmployeeList[i].EmpId,
						name: _this.TotalEmployeeList[i].EmpName
					};
					manualRemainderEmpIds.push(remainderEmpObj)
				}
				jquery('.employer_background_image_calender').each(function() {
					//empNum++;
					jquery(this).addClass('active');
					jquery(this).css('background-size', '31px 32px !important');
					jquery(this).css('background-image', `url('${c.CDNIMAGESBASEURL}/ess/ESSApp/static/Images/timasheet_emp_ic_selected_can.svg')`);

					// let empId = jquery(this).attr('emp_id');
					// let empName = jquery(this).attr('emp_name');
					// var remainderEmpObj = {
					// 	id: empId,
					// 	name: empName
					// };
					// manualRemainderEmpIds.push(remainderEmpObj);

					jquery(this).parent().parent().parent().parent().css({
						border: '2px solid #4a90e2'
					});
				});
				let remtext = `<p style="display: inline-block;font-style: italic;font-weight: 600;color: #073a76;">
									${empNum} employee(s) selected.Select </p>`;
				jquery('#no_of_emp_remainder_num').html(remtext);
				jquery('#no_of_emp_remainder').css('display', 'table');

				store.commit('UpdateManualRemainderEmpIds', manualRemainderEmpIds);

				store.commit('UpdateIsSelectAllForManualRemainders', true);

			   _this.UnSelectedTimesheets = [];
			});

			jquery('.emp_rem_selectNone').on('click', function() {
				jquery('.employer_background_image_calender').each(function() {
					jquery(this).removeClass('active');
					jquery(this).css('background-size', '31px 32px !important');
					jquery(this).css('background-image', 'url(' + jquery(this).attr('background_img') + ')');

					jquery(this).parent().parent().parent().parent().css({
						border: 'None'
					});
				});
				jquery('#no_of_emp_remainder').css('display', 'None');
				jquery('#no_of_emp_remainder_num').html(``);

				store.commit('UpdateManualRemainderEmpIds', []);
				store.commit('UpdateIsSelectAllForManualRemainders', false);
				_this.SelectedTimesheets = [];
				_this.UnSelectedTimesheets = [];
			});

			// jquery('.employee-details').on('click', function() {
			// 	debugger;

			// 	var element = jquery(this).find('.employer_background_image_calender');
			// 	jquery(element[0]).trigger();
			// 	// jquery(this).children()[0]
			// 	// jquery(jquery(this).children()[0]).trigger('click');

			// 	//jquery(this).children().trigger('click');
			// });
			jquery('.employee-details .text-emp-name').click(function(e) {
				e.stopPropagation();
			});
			jquery('.employee-details').unbind('click').click(function() {
				var ele = jQuery(this).find('.employer_background_image_calender');

				jquery(ele).toggleClass('active');
				var manualRemainderEmpIds = store.getters.getManualRemainderEmpIds;
				var remainderObjIndex = manualRemainderEmpIds.findIndex((x) => x.id == empId);
				let empId = jquery(ele).attr('emp_id');
				let empName = jquery(ele).attr('emp_name');
				var remainderEmpObj = {
					id: empId,
					name: empName
				};
				var remainderObjIndex = manualRemainderEmpIds.findIndex((x) => x.id == empId);
				if (jquery(ele)[0].classList.contains('active')) {
					if (remainderObjIndex == -1) {
						manualRemainderEmpIds.push(remainderEmpObj);
						_this.UnSelectedTimesheets.pop(remainderObjIndex,1);
					}
					jquery(ele).parent().parent().parent().parent().css({
						border: '2px solid #4a90e2'
					});
					jquery(ele).css('background-size', '31px 32px !important');
					jquery(ele).css('background-image', `url('${c.CDNIMAGESBASEURL}/ess/ESSApp/static/Images/timasheet_emp_ic_selected_can.svg')`);
				} else {
					if (remainderObjIndex > -1) {
						_this.UnSelectedTimesheets.push(remainderEmpObj);
						manualRemainderEmpIds.splice(remainderObjIndex, 1);
					}
					jquery(ele).parent().parent().parent().parent().css({
						border: 'None'
					});
					jquery(ele).css('background-image', 'url(' + jquery(ele).attr('background_img') + ')');
				}
				_this.SelectedTimesheets = manualRemainderEmpIds;
				let rem_emp_count = manualRemainderEmpIds.length;
				let remtext = ``;
				if (rem_emp_count > 0) {
					remtext = `<p style="display: inline-block;font-style: italic;font-weight: 600;color: #073a76;">
									${rem_emp_count} employee(s) selected.Select </p>`;
					jquery('#no_of_emp_remainder').css('display', 'table');
				} else {
					remtext = ``;
					jquery('#no_of_emp_remainder').css('display', 'None');
				}
				jquery('#no_of_emp_remainder_num').html(remtext);
				store.commit('UpdateManualRemainderEmpIds', manualRemainderEmpIds);
			});
		}
	}
	updateURL() {
		var query = window.location.search.substring(1);
		if (query.length) {
			if (window.history != undefined && window.history.pushState != undefined) {
				window.history.pushState({}, document.title, window.location.pathname);
			}
		}
	}
	updateScrollPositionOnLoadMore() {
		var storePageNo = store.getters.getTimesheetPageNo;
		if (parseInt(storePageNo) > 0) {
			// let PageSize = parseInt(this.pageSize) * (parseInt(storePageNo) + 1);
			// this.pageSize = PageSize;
			this.pageNo = storePageNo
		}
	}
	getUrlVars() {
		var vars = [],
			hash;
		var hashes = window.location.href.slice(window.location.href.indexOf('?') + 1).split('&');
		for (var i = 0; i < hashes.length; i++) {
			hash = hashes[i].split('=');
			vars.push(hash[0]);
			vars[hash[0]] = hash[1];
		}
		return vars;
	}
	refreshCalender() {
		window.allEvtIds = [];
		this.getBodyDOM().html('');
		var cList = store.getters.getTimesheetCustomMonthlyList;
		if (cList.length <= 0) {
			this.getBodyDOM().html('<p style="margin: 100px;" class="text-center">No employees found.</p>');
			//this.getFooterDOM().html('<div style1="border:none !important"></div>');
		} else {
			cList.forEach((c) => {
				this.getBodyDOM().append(MonthsRender(this.year, this.month, c));
			});
			var scrollPosition = store.getters.getTimesheetScrollPosition;
			document.getElementById('CalenderInnerDiv').scrollTop = parseFloat(scrollPosition);
		}
		this.bindEvents();
	}
	makeAjaxCall() {
		//$('.fc-ob-custom-view-pagination').attr('style', 'border: none !important');
		jquery('#no_of_emp_remainder').css('display', 'None');
		jquery('#no_of_emp_remainder_num').html(``);

		store.commit('UpdateManualRemainderEmpIds', []);
		window.allEvtIds = [];
		if (this.searchText.trim() != null && this.searchText.trim() != '') {
			jquery('.fc-cv-remove-btn').css('display', 'inline-block');
			jquery('.fc-cv-search-btn').css('display', 'None');
		} else {
			jquery('.fc-cv-remove-btn').css('display', 'None');
			jquery('.fc-cv-search-btn').css('display', 'inline-block');
		}
		if (this.IsPagefullLoad) {
			this.updateScrollPositionOnLoadMore();
		}
		Loading({ loadingText: 'Fetching data...' });
		var tcycle = store.getters.getTimeSheetFilterValue('TimeSheetCycle');
		if (tcycle == 'Semi-Monthly') {
			tcycle = 'SemiMonthly';
		} else if (tcycle == 'Bi-Weekly') {
			tcycle = 'BiWeekly';
		}
		var dateString = this.year + '-' + this.month + '-01';
		var fromDate = new moment(dateString);
		let val = {
			ProjectId: store.getters.getTimeSheetFilterValue('ProjectTitle'),
			ClientId: store.getters.getTimeSheetFilterValue('ClientName'),
			EndClientOrgName: store.getters.getTimeSheetFilterValue('EndClientName'),
			ReportingAuthorityId: '',
			TimesheetStatus: store.getters.getTimeSheetFilterValue('TimeSheetStatus'),
			ExpenseStatus:store.getters.getTimeSheetFilterValue('ExpenseStatus'),
			TimeSheetCycle: store.getters.getTimeSheetFilterValue('TimeSheetCycle'),
			EmployeeStatus: store.getters.getTimeSheetFilterValue('EmployeeStatus'),
			BillingStatus:store.getters.getTimeSheetFilterValue('BillingStatus'),
			ProjectStatus: store.getters.getTimeSheetFilterValue('ProjectStatus'),
			TaxTerms: store.getters.getTimeSheetFilterValue('TaxTerms'),
			EmploymentType: store.getters.getTimeSheetFilterValue('EmploymentType'),
			InvoiceStatus: store.getters.getTimeSheetFilterValue('InvoiceStatus'),
			TimesheetFromDate: new moment(fromDate).startOf('Month').format('MM/DD/YYYY'),
			TimesheetToDate: new moment(fromDate).endOf('Month').format('MM/DD/YYYY'),

			PageNo: this.pageNo == 0 ? 0 : this.pageNo - 1,
			PageSize: this.pageSize,
			SearchText: this.searchText == 'undefined' || this.searchText == undefined ? '' : this.searchText.trim(),

			TimesheetsSortType: 'EmployeeName',
			IsAscending: true
		};
		if (val != undefined) {
			var obj = { ...val };
		} else {
			obj = '';
		}
		window.ajax.put(`/TimeSheets/Organization/CalenderView?orgId=${this.orgId}`, obj, (res) => {
			store.commit('updateTimeSheetEmployeeIdList', res.data.EmployeeIdList);
			//$('.fc-ob-custom-view-pagination').attr('style', 'border:1px solid #59a2e7; !important');
			Loading({}).close();
			this.TotalCount = res.data.TotalCount;
			this.TotalEmployeeList = res.data.TotalEmployeeList;
			if (res.data.CalendarList && res.data.CalendarList.length > 0) {
				// has employees
				this.CalendarList.push.apply(this.CalendarList, res.data.CalendarList);
				store.commit('updateTimesheetCustomMonthlyList', this.CalendarList);
				// store.commit('updateTimeSheetEmployeeIdList',res.data.EmployeeIdList)
				store.commit('updateTimeSheetSearchText', this.searchText);
				this.getBodyDOM().html('');
				var orgHolidaysList = res.data.HolidayList;
				res.data.CalendarList.forEach((c) => {
					let calenderData = [];
					let timesheetData = c.CalendarList;
					var leaveList = c.LeaveList;
					calenderData.push.apply(calenderData, timesheetData);
					calenderData.push.apply(calenderData, leaveList);
					calenderData.push.apply(calenderData, orgHolidaysList);
					c.CalendarList = calenderData;
					this.getBodyDOM().append(MonthsRender(this.year, this.month, c));
				});
				if (res.data.CalendarList.length > 0) {
					this.getFooterDOM().html(this.PaginationBind());
					// $('.fc-ob-custom-view-pagination').attr('style', 'border:1px solid #59a2e7; !important');
				} else {
					if (this.pageNo == 1) {
						this.getBodyDOM().html('<p style="margin: 100px;" class="text-center">No employees found.</p>');
						this.getFooterDOM().html('');
					} else {
						this.getFooterDOM().html('');
					}
				}
				this.bindEvents();
				this.handleManulRemaindersOnPageLoad();
				if (this.IsPagefullLoad) {
					var scrollPosition = store.getters.getTimesheetScrollPosition;
					document.getElementById('CalenderInnerDiv').scrollTop = parseFloat(scrollPosition);

					this.pageSize = 12;
					this.pageNo = store.getters.getTimesheetPageNo;
				}
				window.bus.fire('openPopoverFromRedirection');
			} else {
				this.getBodyDOM().html('<p style="margin: 100px;" class="text-center">No employees found.</p>');
				this.getFooterDOM().html('');
				this.bindEvents();
				//$('.fc-ob-custom-view-pagination').attr('style', 'border: none !important');
			}
		});
	}

	//----- Helpers End

	initialize() {
		// called once when the view is instantiated, when the user switches to the view.
		// initialize member variables or do other setup tasks.

		// Hide the header toolbar when view initialize
		jquery(this.el).parent().prev().hide();

		this.setDefault();

		jquery(this.el).html(this.htmlContainer);
		events.listen('applyFilter', (val) => {
			jquery('#no_of_emp_remainder').css('display', 'None');
			jquery('#no_of_emp_remainder_num').html(``);

			store.commit('UpdateIsSelectAllForManualRemainders', false);
			this.SelectedTimesheets = [];
			this.UnSelectedTimesheets = [];

			this.CalendarList = [];
			this.getBodyDOM().html(''); // Clear existing data
			this.getFooterDOM().html(''); // Clear existing data
			//	$('.fc-ob-custom-view-pagination').attr('style', 'border: none !important');
			this.pageNo = 1;
			this.pageNumberUrlHandling();
			this.makeAjaxCall();
		});
		bus.listen('refreshCalender', () => {
			this.CalendarList = [];
			this.getBodyDOM().html('');
			this.getFooterDOM().html('');
			this.makeAjaxCall();

			jquery('#no_of_emp_remainder').css('display', 'None');
			jquery('#no_of_emp_remainder_num').html(``);
			store.commit('UpdateManualRemainderEmpIds', []);
			store.commit('UpdateIsSelectAllForManualRemainders', false);
			this.SelectedTimesheets = [];
			this.UnSelectedTimesheets = [];

		});
		bus.listen('UnselectEmployees', () => {
			let _this = this;
			jquery('.employer_background_image_calender').each(function() {
				jquery(this).removeClass('active');
				jquery(this).css('background-size', '31px 32px !important');
				jquery(this).css('background-image', 'url(' + jquery(this).attr('background_img') + ')');

				jquery(this).parent().parent().parent().parent().css({
					border: 'None'
				});
			});
			jquery('#no_of_emp_remainder').css('display', 'None');
			jquery('#no_of_emp_remainder_num').html(``);

			store.commit('UpdateManualRemainderEmpIds', []);
			store.commit('UpdateIsSelectAllForManualRemainders', false);
			_this.SelectedTimesheets = [];
			_this.UnSelectedTimesheets = [];

		});
	}

	destroy() {
		// Show the header toolbar when view initialize
		jquery(this.el).parent().prev().show();

		this.unrenderSkeleton();

		super.destroy();
	}

	renderSkeleton() {
		// responsible for displaying the skeleton of the view within the already-defined
		// this.el, an HTML element
	}

	unrenderSkeleton() {
		// should undo what renderSkeleton did
		this.clearDOM();
	}

	renderDates(dateProfile) {
		// responsible for rendering the given dates
	}

	unrenderDates() {
		// should undo whatever renderDates does
	}

	renderEvents(eventStore, eventUiHash) {
		// responsible for rendering events
		this.setDefault();

		let key = Object.keys(eventStore.defs)[0];

		let eventObj = eventStore.defs[key].extendedProps.EventObj;

		this.year = eventObj.year;
		this.month = eventObj.month;
		this.orgId = eventObj.orgId;
		this.searchText = eventObj.searchText;
		this.IsPagefullLoad = eventObj.IsPagefullLoad;
		if(eventObj.PageNo != undefined && eventObj.PageNo != null && eventObj.PageNo != 0)
		{
		this.pageNo = eventObj.PageNo;
		}
		else{
			this.PageNo = 1;
		}

		this.clearDOM();

		this.getHeaderDOM().html(WeekDayRender(this.year, this.month));
		jquery('.fc-cv-remove-btn').css('display', 'None');
		if (this.searchText != null && this.searchText != '' && this.searchText != 'undefined' && this.searchText != undefined) {
			jquery('.fc-cv-remove-btn').css('display', 'inline-block');
			jquery('.fc-cv-search-input').val(this.searchText);
		} else {
			jquery('.fc-cv-remove-btn').css('display', 'None');
		}
		this.makeAjaxCall();
	}

	unrenderEvents() {
		// should undo whatever renderEvents does
		this.clearDOM();
	}
}

export default createPlugin({
	views: {
		customViewMonthly: CustomViewMonthly
	}
});



// WEBPACK FOOTER //
// ./src/components/ESSProfile/Timesheets/Calender/CustomViews/custom-view-monthly.js